const kanopiSurcharge = {
    surchargeZoneLs: 'surchargeZone',
    zoneHasChangedLS: 'zoneHasChanged',
    expectedSurchargeLS: 'expectedSurcharge',
    showSurchargeAdviceLS: 'showSurchargeAdvice',
    expirationTimeLS: 'expireSurcharge',
    asmZipcode: 'zipcode',

    /**
     * Get the surcharge zone based on the ZIP code detected via an API. Only when there is no customer zipcode set.
        * @param  string - zipcode: New user zipcode
        * @dependency  string - customerDefaultZipCode: This is only available when the user has a default ZIP code, which is provided by Liquid in customer.default_address.zip
    */
    _setZoneByApi: function(zipcode) {
        const zoneHasChanged = this._getZoneHasChangedLs();
        if((zoneHasChanged !== 'true')) {
            this._setZone(zipcode);
        }
    },

    /**
        * Get the new surcharge zone based on the customer default Zip code and store it in ls.
        * @dependency  string - customerDefaultZipCode
    */
    _setZoneByCustomerZipCode: function() {
        if(typeof customerDefaultZipCode === 'undefined' || customerDefaultZipCode === 'false' || this._getZoneHasChangedLs() === 'true') return;
        const group = this._getZone(customerDefaultZipCode);
        const value = group ? group : 'free';
        this._validateDifferentZone(value);
    },

    /**
        * Get the new surcharge zone when the user changes their ZIP code on the cart or checkout page
        * @param  string - zipcode: New user zipcode
    */
    _setZoneByUser: async function(zipcode) {
        const zone = this._getZone(zipcode);
        const isNewZone = this._validateDifferentZone(zone);
        const timer = 1000;
        if(isNewZone || !(CartJS?.cart?.attributes?.surchargeZipCode)) {
            this._handleExpirationTime();
            this._setExpectedSurcharge();
            this._setZoneHasChangedLs('true');
            await this._updateLineItemProps();
            setTimeout(this._showChangeAdvice.bind(this), timer);     
            return false;
        }       
        return true;
    },
    /**
        * Set the new surcharge zone when ASM detects a different zipcode
        * @param  string - zipcode: New user zipcode
    */
    _setZoneByAsm: function(zipcode) {
        if(this._getZoneHasChangedLs() === 'true') return;
        this._setZoneByUser(zipcode);
    },
    /**
        * Handle the surcharge previous to update the zipcode
    */
    _setExpectedSurcharge: function() {
        const checkout = $('.checkout-template');
        let expectedSurcharge = '0';
        if(checkout.length && typeof expectedSurchargeNew !== 'undefined') {
            this._setExpectedSurchargeLs(expectedSurchargeNew / 100);
        }else if(typeof getTotalRPADiscount === 'function') {
            expectedSurcharge = getTotalRPADiscount(true);
            this._setExpectedSurchargeLs(expectedSurcharge);
        }
    },
    /**
        * Set LS value for the expectedSurcharge variable
        * @param  string - expectedSurcharge: total surcharge in the order
    */
    _setExpectedSurchargeLs: function(expectedSurcharge) {
        localStorage.setItem(this.expectedSurchargeLS, expectedSurcharge);
    },
    /**
        * Get LS value for the expectedSurcharge variable
    */
    _getExpectedSurchargeLs: function() {
        const storedSurcharge =  localStorage.getItem(this.expectedSurchargeLS);
        return storedSurcharge ? parseFloat(storedSurcharge) : 0;
    },
    /**
        * Set the Local Storage (LS) value for surcharge expiration time
        * @param  string - ttl: string timestamp with the expiration time
    */
    _setExpirationTimeLs: function(ttl) {
        localStorage.setItem(this.expirationTimeLS, ttl);
    },
    /**
        * Get Local Storage (LS) value for surcharge expiration time
    */
    _getExpirationTimeLs: function() {
        return  localStorage.getItem(this.expirationTimeLS);
    },
    /**
        * Remove Local Storage (LS) value for surcharge expiration time
    */
    _deleteExpirationTimeLs: function() {
        return  localStorage.removeItem(this.expirationTimeLS);
    },
    /**
        * Remove Local Storage (LS) value for asm zipcode
    */
    _deleteAsmZipcode: function() {
        return  localStorage.removeItem(this.asmZipcode);
    },

    /**
        * Set LS value for the showSurchargeAdvice variable
        * @param  boolean - val: true or false depending if the message should be shown or not.
    */
    _setShowSurchargeAdviceLs: function(val) {
        localStorage.setItem(this.showSurchargeAdviceLS, val);
    },
    /**
        * Get LS value for the showSurchargeAdvice variable
    */
    _getShowSurchargeAdviceLs: function() {
        return localStorage.getItem(this.showSurchargeAdviceLS);
    },
    /**
         * Get the new surcharge zone based on the user's ZIP code and store it in LS.
         * @param  string - zipcode: New user zipcode
     */
    _setZone: function(zipcode) {
        if (typeof Shopify.surchargeGroups === 'undefined') return;
        const group = this._getZone(zipcode);
        this._setSurchargeLs(group);
    },
    /**
        * Validate whether the new zone is different from the current one, and if it is, set the new group in LS.
        * @param  string - group: Current group key
        * @return boolean -  Returns true when it's a new zone, and false when it's the same
    */
    _validateDifferentZone: function(group) {
        const currentState = this._getSurchargeLs();
        if(group != currentState) {
            this._setSurchargeLs(group);
            return true;
        }
        return false;
    },
    /**
        * Get the surcharge zone base on zipcode.
        * @dependency  object - Shopify.surchargeGroups - Surcharge metafield values.
        * @param  string - zipcode: User zipcode
        * @return string -  There are 2 possible values:
        *   1- Returns free when zipcode isn't in a surcharge area. 
        *   2- Returns group key when zipcode is in a surcharge area.
    */
    _getZone: function(zipcode) {
        if(typeof zipcode !== 'undefined') {
            const detectedCountryCode = localStorage.getItem('detectedCountryCode');
            const parsedZipCode = typeof zipcode !== 'string' ? `${zipcode}` : zipcode;
            for (const group in Shopify.surchargeGroups) {
                if(Shopify.surchargeGroups[group].addresses){
                    for (const addi in Shopify.surchargeGroups[group].addresses) {
                        let add = Shopify.surchargeGroups[group].addresses[addi];
                        if(
                            detectedCountryCode == add.customer_country_code && 
                            zipcode == add.shipping_zip_code
                        ){
                            localStorage.setItem('detectedTag',add?.tag);
                            return group;
                        }
                    }
                }
            }
            for (const group in Shopify.surchargeGroups) {
                if (Shopify.surchargeGroups[group].zip_codes.includes(parsedZipCode)){
                    localStorage.setItem('detectedTag','');
                    return group;
                } 
            }
        }
        return 'free';
    },
    
    /**
        * Set LS values for discounts
        * @param  boolean - hasDiscount: true/false depending if we need to display regular discounts
        * @param  boolean - hasVolDiscount: true/false depending if we need to display volume discounts
    */
    _setDiscountsLS(hasDiscount, hasVolDiscount) {
        localStorage.setItem("applyDiscount", hasDiscount);
        localStorage.setItem("applyVolDiscount", hasVolDiscount);
    },

    /**
        * Set LS value for volume discounts
        * @param  boolean - hasVolDiscount: true/false depending if we need to display volume discounts 
    */
    _setVolumeDiscountsLS(hasVolDiscount) {
        localStorage.setItem("applyVolDiscount", hasVolDiscount);
    },
    /**
     * Helper fpr update LS and line item properties when we move to a non surcharge area
     */
    _handleDiscounts(forceDiscount = false) {
        const applyDiscount = typeof checkDiscountsDateRange === "function" ? checkDiscountsDateRange() : forceDiscount;
        const applyVolDiscount = typeof checkDiscountsDateRange === "function" ? checkDiscountsDateRange("volume") : forceDiscount;
        this._setDiscountsLS(applyDiscount, applyVolDiscount);
        if(typeof updateDiscounts !== 'undefined') {
            updateDiscounts._updateLSValues();
            updateDiscounts._init();
        }
    },
    /**
        * Set the new LS value of the surcharge zone
    */
    _setSurchargeLs: function(value) {
        localStorage.setItem(this.surchargeZoneLs, value);
    },

    /**
        * Retrieve the LS value of the surcharge zone
    */
    _getSurchargeLs: function() {
        const regionID = getParameterByName('region_id'); 
        if(regionID){
            const numericPartMatch = regionID.match(/\d+/);
            if(numericPartMatch){
                const numericPart = regionID ? numericPartMatch[0] : '';
                const zip_set = `zip_set${numericPart}`;
                surchargeZone = zip_set;
                return surchargeZone;
            }
        }
        return localStorage.getItem(this.surchargeZoneLs);
    },

    /**
        * Set it to true when the user has manually changed the zone in either the cart or checkout page.
    */
    _setZoneHasChangedLs: function(value) {
        localStorage.setItem(this.zoneHasChangedLS, value);
    },
    
    /**
        * Retrieve the value of the has changed zone LS variable
    */
    _getZoneHasChangedLs: function() {
        return localStorage.getItem(this.zoneHasChangedLS);
    },

    /**
        * Get the surcharge % for the current zone.
        * @param  {object} - surchargeData: surcharge value (metafield coming form variant/product)
        * @param  {string} - surchargeZone: current surcharge zone
        * @return boolean -  Returns the surcharge price according to the zone and 0 if the zone isn't found.
    */
    _getSurchargeHelper: function(data, surchargeZone) {
        const surchargeData = typeof data == 'string' ? JSON.parse(data) : data;
        if(surchargeData){
            const surchargeValue = surchargeData.find(area => area.key === surchargeZone);
            let surcharge = false;
            if(typeof surchargeValue?.surcharge !== 'undefined') {
                surcharge = surchargeValue.surcharge;
                localStorage.setItem('surchargeValue',surcharge)
            }
            return surcharge;
        }
    },

    /**
        * Get the surcharge from product/variant metafields for the current zone.
        * @param  object - current variant metafields - These are coming from kanopi-common-js
        * @return boolean -  Returns the surcharge price according to the zone and 0 if the zone isn't found.
    */
    _getProductSurchargeAmount: function(metafields) {
        let expectedSurcharge = '0';
        let applyShopSurcharge = true;
        const setValues = (surcharge, applyShop) => {
            expectedSurcharge = surcharge;
            applyShopSurcharge = applyShop;
        }
        let surchargeZone = localStorage.getItem('surchargeZone');
        const regionID = getParameterByName('region_id'); 
        if(regionID){
            const numericPartMatch = regionID.match(/\d+/);
            if(numericPartMatch){
                const numericPart = regionID ? numericPartMatch[0] : '';
                const zip_set = `zip_set${numericPart}`;
                surchargeZone = zip_set
            }
        }
        if(surchargeZone && surchargeZone !== 'free' && metafields.has_surcharge === 'true') {
            const shopSurcharge = this._getSurchargeAmount();
            const productSurcharge = metafields.product_surcharge;
            const variantSurcharge = metafields.surcharge;
            if(variantSurcharge !== 'false') {
                const variantSurchargeVal = this._getSurchargeHelper(variantSurcharge, surchargeZone);
                if (variantSurchargeVal !== false ) setValues(variantSurchargeVal, false);
            }
            if(productSurcharge !== 'false' && applyShopSurcharge) {
                const productSurchargeVal = this._getSurchargeHelper(productSurcharge, surchargeZone);
                if (productSurchargeVal !== false ) setValues(productSurchargeVal, false);
            }
            if (applyShopSurcharge) expectedSurcharge = shopSurcharge;
            localStorage.setItem('surchargeValue',shopSurcharge)
        }
        return expectedSurcharge;
    },

    /**
        * Get the shop surcharge type for a zone.
        * @return string -  Returns if the zone is lower-charge o surcharge area.
    */
    _getSurchargeType: function (zone) {
        if(Shopify[zone]) {
          if( Shopify[zone].surcharge.includes('-')){
            return 'lowerCharge'
          }
          if (!Shopify[zone].surcharge.includes('-')) {
            return 'surcharge'
          }  
        }
        if (zone == 'free' || zone == null) {
            return 'free'
        }
    },


    /**
        * Get the shop surcharge for the current zone.
        * @return string -  Returns the surcharge data according to the zone and '0' if the zone isn't found.
    */
    _getSurchargeAmount: function() {
        const group = this._getSurchargeLs();
        if(group) {
            return typeof Shopify.surchargeGroups[group]?.surcharge !== 'undefined' ? Shopify.surchargeGroups[group].surcharge : '0';
        }
        return '0';
    },
    /**
        *Check if expected surcharge is higher than the previous surcharge
    */
    _handleAdviceHelper: function() {
        const checkout = $('.checkout-template');
        const cart = $('.template-cart');
        const oldSurcharge = this._getExpectedSurchargeLs();
        const compareSurcharges = (oldSurcharge, newSurcharge) => {
            const displayMessage = oldSurcharge < newSurcharge ? true : false;
            this._setShowSurchargeAdviceLs(displayMessage);
        }

        if(checkout.length && typeof expectedSurchargeNew !== 'undefined') {
            const newSurcharge = expectedSurchargeNew / 100;
            compareSurcharges(oldSurcharge, newSurcharge);
        }else if(cart.length && typeof getTotalRPADiscount === 'function') {
            const newSurcharge = parseFloat(getTotalRPADiscount(true));
            compareSurcharges(oldSurcharge, newSurcharge);
        }

    },
    /**
        *Display message advising customers about the possible change in prices
    */
    _showChangeAdvice: function() {
        const checkout = $('.checkout-template');
        const message = $('.js-rpa-msg-wrapper');
        const zoneHasChanged = this._getZoneHasChangedLs();
        if(zoneHasChanged === 'true') this._handleAdviceHelper();
        const showAdvice = this._getShowSurchargeAdviceLs();
        if(showAdvice !== 'true'){
           if(message.length) {
                message.removeClass('active');
            } 
        } else {
            if(checkout.length) {
                this._getExpectedSurchargeLs();
                this._handleCheckoutAdvice();
            }else if(message.length) {
                message.addClass('active');
            } 
        }
    },
    /**
        * Inject message in checkout advising customers about the possible change in prices
    */
    _handleCheckoutAdvice: function() {
        const orderSummarySections = $('.order-summary__sections');
        const messageHtml = $('.js-rpa-msg-wrapper');
        if (typeof rpaTextMessage === 'undefined' || orderSummarySections.length === 0 || messageHtml.length > 0) return;
        const message = `
            <div class="js-rpa-msg-wrapper active tw-rpa-message-wrapper">
                <p class="tw-rpa-message"><span>Note: </span>${rpaTextMessage}</p>
            </div>
        `;
        orderSummarySections.append(message);
    },
    /**
        * Update line item properties with the new rpa
    */
    _updateLineItemProps: async function() {
        if (typeof Shopify.lineItems === 'undefined') return;
        var items, cartObject;
    
        // Get cart items using Cart.js
        if (typeof CartJS !== 'undefined') {
            items = CartJS.cart.items;
            cartObject = CartJS;
        } else {
            cartObject = await this._getCartItems();
            items = cartObject?.items;
        }
    
        let itemsToUpdate = [];
        let surchargeAccum = 0;
        const applyVolDiscounts = this._checkDiscountsDateRange('volume');
        const shopSurcharge = this._getSurchargeAmount();
    
        const updateVolumeProps = (props, newVals = {}, type = 'remove') => {
            if (type === 'add') {
                if (newVals.hasVolDiscount === 'true') {
                    props._volumeDiscount = newVals.volumeDiscount;
                    props._volumeMsg = newVals.volumeMsg;
                    props._volumeQuantity = newVals.volumeQuantity;
                }
                if (applyVolDiscounts === true) this._setVolumeDiscountsLS(true);
            } else {
                const { _volumeDiscount, _volumeDiscountApplied, _volumeMsg, _volumeQuantity, ...others } = props;
                props = others;
                this._setVolumeDiscountsLS(false);
            }
            return props;
        };
    
        // Process items in the cart
        items.map((item, index) => {
            const variantData = Shopify.lineItems[item.id];
            const expectedSurcharge = this._getProductSurchargeAmount(variantData);
    
            if (item.properties.hasOwnProperty('__rpaPercentage') && expectedSurcharge != item.properties.__rpaPercentage) {
                item.properties.__rpaPercentage = expectedSurcharge;
    
                if (shopSurcharge !== '0') {
                    if (
                        (shopSurcharge.includes("-") &&
                        typeof enable_vol_lowcharge !== "undefined" &&
                        enable_vol_lowcharge !== "true") ||
                        (typeof enable_vol_surcharge !== "undefined" &&
                        enable_vol_surcharge !== "true")
                    ) {
                        item.properties = updateVolumeProps(item.properties);
                    } else {
                        item.properties = updateVolumeProps(item.properties, variantData, "add");
                    }
                } else {
                    item.properties = updateVolumeProps(item.properties, variantData, "add");
                }
    
                if (expectedSurcharge !== '0' && !expectedSurcharge.includes('-')) {
                    const itemSurcharge = parseInt(expectedSurcharge) / 100;
                    const subtotalSurcharge = Math.floor(item.original_line_price * itemSurcharge);
                    surchargeAccum += subtotalSurcharge;
                }
    
                // Add item for updating in Cart.js
                const key = typeof CartJS !== 'undefined' ? index + 1 : item.key;
                itemsToUpdate.push({
                    index: key,  // CartJS expects a 1-based index
                    quantity: item.quantity,
                    properties: item.properties
                });
            }
        });
    
        try {
            // Wait for cart line item updates
            if (itemsToUpdate.length) {
                if (typeof CartJS !== 'undefined') {
                    for (const item of itemsToUpdate) {
                        // await CartJS.updateItem(item.index, item.quantity, item.properties);
                    }
                } else {
                    $('#continue_button').prop('disabled', true);
                    const handleRequest = async (data, endpoint = 'change') => {
                        const request = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) };
                        return await this.setCartItem(request, endpoint);
                    };
                    for (const item of itemsToUpdate) {
                        const object = {
                            "id": item.index,
                            "quantity": item.quantity,
                            "properties": item.properties,
                        };
                        await handleRequest(object);
                    }
        
                    if (typeof saveAddressLs === 'function') saveAddressLs();
                    if (typeof surchargeVariantId !== 'undefined') {
                        const payload = { "updates": {} };
                        payload.updates[surchargeVariantId] = surchargeAccum;
                        await handleRequest(payload, 'update');
                    }
        
                    if ($('.field__message--error').length && typeof Shopify != 'undefined' && typeof Shopify.Checkout != 'undefined' && Shopify.Checkout.step === 'contact_information') {
                        window.location.href = window.location.href;
                    } else {
                        window.location.reload(true);
                    }
                }
            }
    
            // Prepare attributes for the cart update
            const surchargeZone = this._getSurchargeLs();
            const surchargeZipCode = document.getElementById('asm-force-zip').value;
            const surchargeValue = this._getSurchargeAmountForZone(surchargeZone);
            let newtag = localStorage.getItem('detectedTag');
    
            // Merge all attributes into one object
            const attributesToUpdate = {
                'surchargeZone': surchargeZone,
                'surchargeZipCode': surchargeZipCode,
                'surchargeValue': surchargeValue,
            };
    
            if (cartObject.attributes?.OrderTag != newtag) {
                attributesToUpdate['OrderTag'] = newtag;
            }
            // Update cart attributes using CartJS or fallback method
            if (typeof CartJS !== 'undefined') {
                await CartJS.setAttributes(attributesToUpdate, {
                    "success": function(data) {
                        updateSections(`${location.protocol}//${location.host}${location.pathname}?sections=cart-template,cart_object`, 1);
                    },
                    "error": function(error) {
                        console.error('Error updating cart:', error);
                    }
                });
            }
            else {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: attributesToUpdate })
                });
            }
    
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    },                  

    /**
     * Get the surcharge amount for a specific zone.
     * @param {string} zone - The surcharge zone
     * @return {string} - The surcharge amount for that zone
     */
    _getSurchargeAmountForZone: function(zone) {
        if (zone) {
            return typeof Shopify.surchargeGroups[zone]?.surcharge !== 'undefined' ? Shopify.surchargeGroups[zone].surcharge : '0';
        }
        return '0';
    },

    /**
        * Returns true or false if the customer is in a surcharge zone
        * @return boolean
    */
    _isSurchargeZone: function() {
        const zone = this._getSurchargeLs();
        return zone && (zone !== 'false' && zone !== 'free') ? true : false;
    },
    _isLowcharge: function(){
        const surcharge = this._getSurchargeAmount();
        const isLowcharge = surcharge !== false && surcharge.includes('-');
        return isLowcharge;
    },
    /**
        * GET request that returns an object with the items in the cart
        * @return cart items
    */
    _getCartItems: async function() {
        let data = [];
        try {
            data = await $.getJSON('/cart.js');
        } catch (error) {
            console.log(error);
        }
        return data; 
    },
    /**
        * POST request that  updates a line_item in the cart.
        * @return cart items
    */
    setCartItem: async function(item, endpoint = 'change') {
        try {
            const response = await fetch(`/cart/${endpoint}.js`, item);
            if (!response.ok){
                return false;
            }

            return response.json();
          }catch(err){
            console.log(err);
        }
        return false;
    },
    /**
        * Returns the price with the surcharge % applied.
        * @param  string - price: Current variant price or price per sqft
        * @param  string - surcharge: Surcharge percentage to apply
        * @param  boolean - isShopifyFormat: For prices coming from Shopify, no special formatting is required. However, for regular prices, such as 9.99, it is necessary to multiply the price by 100 before format it
        * @return string - Returns the correct price with the surcharge tax applied in money format
    */
    _getSurchargePriceHelper: function(price, surcharge, isShopifyFormat = true) {
        if (typeof theme.Currency?.formatMoneyNoRound !== 'function' || !price) return false;
        let itemPrice = typeof price === 'string' ? parseFloat(price) : price;
        itemPrice = isShopifyFormat ? itemPrice : itemPrice * 100;
        const surchargeVal = itemPrice * (surcharge / 100);
        let surcharge_price = 0;
        if(surcharge){
            surcharge_price = surcharge.includes('-') ? surchargeVal : Math.round(surchargeVal);
        }
        const finalPrice = surcharge_price + itemPrice;
        return theme.Currency.formatMoney(finalPrice, theme.moneyFormat);
    },
    /**
     * Set all values stored in Local Storage (LS) to false, restarting the zone according to the detected API
     *  * @param  string - zipcode: Zipcode detected by the API which will be used to identify the surcharge zone
     */
    _restartLsValues: function(zipcode = false) {
        this._setZoneHasChangedLs(false);
        this._setShowSurchargeAdviceLs(false);
        this._setExpectedSurchargeLs(0);
        this._deleteExpirationTimeLs();
        this._deleteAsmZipcode();
        if(zipcode) this._setZoneByApi(zipcode);
    },
    /*
       * Manage the expiration time for manually entered customer zip codes and save the value in Ls.
    */
    _handleExpirationTime: function() {
        if(typeof surchargeTtl === 'undefined') return;
        const ttl = parseInt(surchargeTtl);
        if(ttl > 0) {
            const now = new Date();
            let expirationDate = new Date(now);
            expirationDate.setDate(now.getDate() + ttl);
            this._setExpirationTimeLs(expirationDate);
        }
    },
    /*
       * Review whether the expiration value stored in Local Storage (LS) has expired; if so, restart the surcharge zone based on the zone detected by the zipcode API.
    */
    _checkExpirationTime: function() {
        const checkout = $('.checkout-template');
        const expirationDate = this._getExpirationTimeLs();
        if (expirationDate === null || checkout.length > 0) return;
        const now = new Date();
        const expiry = new Date(expirationDate);
        if(now > expiry) {
            const detectedZipcode = localStorage.getItem('detectedZipcode');
            const zipcode = detectedZipcode === null ? false : detectedZipcode;
            this._restartLsValues(zipcode);
        }
    },
    /*
        * Check if discounts are enable
    */
    _checkDiscountsDateRange(discountType = "regular") {
        if (
        typeof disableDsc === "undefined" ||
        typeof disableVolDsc === "undefined" ||
        typeof dscStartDate === "undefined" ||
        typeof dscEndDate === "undefined"
        )
        return false;
        
        const disable_dsc = discountType === 'regular' ? disableDsc : disableVolDsc;
        let apply_discounts = false;
        if ( disable_dsc !== "true") {
            const now = new Date();
            const start_date = getEstTimeZone(dscStartDate);
            const end_date = getEstTimeZone(dscEndDate);
            if (now > start_date && now <= end_date) {
                apply_discounts = true;
            }
        }
        return apply_discounts;
    },

    /*
        *Calculate expected surcharge for the items in the cart
    */
    _getCartSurcharge(items) {
        return items.reduce((total_surcharge, item) => {
            const itemSurchargeProp = item.properties.hasOwnProperty('__rpaPercentage') ? item.properties.__rpaPercentage : '0';
            if(itemSurchargeProp != '0' && !itemSurchargeProp.includes('-')) {
                const surchargePercentage =  itemSurchargeProp / 100;
                const rpaCost = Math.round( surchargePercentage * item.original_line_price);
                return total_surcharge + rpaCost;
            }
            return total_surcharge;
        },0);
    },
    /*
        *Get totol rpa items in the cart
    */
    _getCurrentCartSurcharge(items) {
        const rpaItem = items.find(item => item.id == surchargeVariantId);
        return rpaItem ? rpaItem.quantity : 0;
    },
    /*
        *Handle when rpa item should be updated in the cart
    */
    _handleCartSurcharge(items) {
        if(typeof surchargeVariantId === 'undefined' || typeof CartJS === 'undefined') return;
        const addingSurchargeHelper = (value) => {
            if (typeof addingSurcharge !== 'undefined') addingSurcharge = value;
        }
        
        const expectedSurcharge = this._getCartSurcharge(items);
        const currentSurcharge = this._getCurrentCartSurcharge(items);
        if(currentSurcharge !== expectedSurcharge) {
            addingSurchargeHelper(true);
            if(currentSurcharge === 0) {
                // console.log(surchargeVariantId,'surchargeVariantId')
                // CartJS.addItem(parseInt(surchargeVariantId), expectedSurcharge, {}, {
                //     "success": function(data, textStatus, jqXHR) {
                //         addingSurchargeHelper(false);
                //     }
                //   });
            }else {
                // console.log()
                // const itemIndex = items.findIndex((item) => item.id == surchargeVariantId);
                // const itemIndexToUpdate = itemIndex + 1;
                // CartJS.updateItem(itemIndexToUpdate, expectedSurcharge, {
                //     "success": function(data, textStatus, jqXHR) {
                //         addingSurchargeHelper(false);
                //     }
                // });
            }
        }
    }
}
$(document).on("ready", function() {
    kanopiSurcharge._showChangeAdvice();
    kanopiSurcharge._checkExpirationTime();
});

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}